import * as Joi from 'joi';

const modelSchemaOptionsSchema = Joi.object().keys({ syntaxError: Joi.string().required() });

export const modelOptionsSchema = Joi.object()
  .keys({
    validate: Joi.bool().default(true),
    hover: Joi.bool().default(false),
    autoComplete: Joi.bool().default(false),
    schema: modelSchemaOptionsSchema,
  })
  .required();
